import React from 'react'
import PageList from '../../components/PageListAPI'
import { deleteWorkerRating, getWorkerRatingList } from '../../api/worker'
import { useCan } from '../../hooks/useCan';
import { SLUGS } from '../../enum/permissions.enum';

export default function RatingList (props) {
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      name='workerList'
      title='Оценка работников'
      columns={[
        { id: 'date', name: 'Дата', type: 'date', formatDate: 'LL' },
        { id: 'worker', name: 'Работник' },
        { id: 'user', name: 'Добавил' },
        { id: 'star', name: 'Оценка' },
      ]}
      createItem={can(SLUGS.CATALOG.WORKER.MANAGE)}
      deleteItem={can(SLUGS.CATALOG.WORKER.MANAGE)}
      loadAPI={{
        request: getWorkerRatingList,
        transform: (res => {
          return {
            count: res.count,
            get: res.get.map(obj => {
              return {
                id: obj.id,
                star: obj.star,
                date: obj.date,
                worker: obj.name + ' ' + obj.surname + ' ' + obj.patronymic,
                user: obj.userName + ' ' + obj.userSurname
              }
            })
          }
        }),
      }}
      
      deleteAPI={deleteWorkerRating}
      headerInit={{
        sortBy: 'surname',
        sortDirection: 'desc',
      }}
      {...props}
    />
  </div>
}